import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	updatedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	updatedLabel: {
		id: 'updated-date.read.updated-label',
		defaultMessage: 'Updated',
		description: 'Label for updated field',
	},
});
export default messages;
